"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("./Button"));

require("./ButtonEdit.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ButtonView extends _react.default.Component {
  render() {
    const _this$props = this.props,
          label = _this$props.label,
          icon = _this$props.icon,
          type = _this$props.type,
          link = _this$props.link,
          onClick = _this$props.onClick;
    let classNames = "admin-button  admin-button--edit";

    if (type) {
      classNames = classNames + "  admin-button--edit-" + type;
    }

    return _react.default.createElement(_Button.default, {
      classNames: classNames,
      link: link,
      onClick: onClick,
      icon: icon,
      label: label
    });
  }

}

var _default = ButtonView;
exports.default = _default;
module.exports = exports.default;